import { createContext, useContext } from 'react';

export interface DualNavContextType {
  widthState: 'collapsed' | 'expanded';
}

const DualNavContext = createContext<DualNavContextType>({
  widthState: 'expanded',
});

const useDualNavContext = () => {
  return useContext(DualNavContext);
};

export { DualNavContext, useDualNavContext };
